import { Border } from '../Input/index.types';
import { appendClassProps } from '../util';
export const applyInputStyles = ({ leftIcon, rightIcon, showErrorMessage, inputClassName, disabled, overrideCursor, border, transparent }) => {
    let backgroundColor = 'bg-white';
    let textColor = 'text-blue-800';
    if (transparent) {
        backgroundColor = 'bg-transparent';
    }
    else if (disabled) {
        backgroundColor = 'bg-gray-150';
        textColor = 'text-gray-600';
    }
    let borderClass = showErrorMessage
        ? 'border-red-400'
        : 'border-gray-300 hover:border-gray-400 focus:border-blue-800';
    if (border === Border.bottom) {
        borderClass = `border-b ${borderClass}`;
    }
    else if (border === Border.none) {
        borderClass = `border-0 ${borderClass}`;
    }
    else if (border === Border.outline) {
        borderClass = `border ${borderClass}`;
    }
    else {
        borderClass = `border ${borderClass}`;
    }
    return `rounded-none pt-1 pb-1 outline-none placeholder-gray-400 w-full ${backgroundColor} ${textColor} text-base rounded-sm
  ${leftIcon ? ' pl-9' : ' pl-2'}${rightIcon && !leftIcon ? ' pr-9' : ' pr-2'} ${borderClass} ${overrideCursor ? '' : disabled ? 'cursor-not-allowed' : 'cursor-text'} ${appendClassProps(inputClassName)}`;
};
//# sourceMappingURL=util.js.map